import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      width: '100%',
      maxWidth: '100%',

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        flexDirection: 'column',
      },
    },
    skeletonRoot: {
      extend: 'root',
      height: 500,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        height: '100vh',
      },
    },

    productWrapper: {
      flex: 1,
      position: 'relative',
      zIndex: 1,
      width: '100%',

      [mediaQuery(1023)]: {
        paddingBottom: Spacings.s48,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        paddingBottom: Spacings.s0,
      },
    },

    mediaWrapper: {
      flex: 1,
      padding: Spacings.s24,

      [mediaQuery(1023)]: {
        minHeight: 318,
      },
    },
  }),
  { name: 'banner-with-background-video' },
);

export default useStyles;
